/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Settings_TitleInputs */

const en_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing & Sync Settings`)
};

const fr_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametres de minutage et synchronisation`)
};

const de_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit- und Synchronisierungseinstellungen`)
};

const it_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di temporizzazione e sincronizzazione`)
};

const ru_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки времени и синхронизации`)
};

const es_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de tiempo y sincronización`)
};

const zh_cn2_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定时和同步设置`)
};

const ja_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングと同期の設定`)
};

const hi_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय और सिंक सेटिंग्स`)
};

const pt_pt2_timing_sync_settings_title = /** @type {(inputs: Timing_Sync_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de tempo e sincronização`)
};

/**
* | output |
* | --- |
* | "Timing & Sync Settings" |
*
* @param {Timing_Sync_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_settings_title = /** @type {((inputs?: Timing_Sync_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_settings_title(inputs)
	if (locale === "de") return de_timing_sync_settings_title(inputs)
	if (locale === "it") return it_timing_sync_settings_title(inputs)
	if (locale === "ru") return ru_timing_sync_settings_title(inputs)
	if (locale === "es") return es_timing_sync_settings_title(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_settings_title(inputs)
	if (locale === "ja") return ja_timing_sync_settings_title(inputs)
	if (locale === "hi") return hi_timing_sync_settings_title(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_settings_title(inputs)
	return en_timing_sync_settings_title(inputs)
});